/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

const headerComponent = {
  templateUrl: 'ajs/header/header.html',
  controllerAs: 'headerCtrl',
  controller: ['$cookies', '$location', '$log', '$rootScope', '$scope', '$state', '$stateParams', '$timeout', '$translate',
    '$window', 'Restangular', 'BulbActivityService', 'BulbAuthService', 'BulbBusyService',
    'BulbBrowserService', 'BulbModalService', 'BulbPageService', 'BulbRecommendService', 'BulbUnitService',
    'AUTHOR_TABS', 'Foundation', 'SEARCH', 'RecordEventService', 'TourService', HeaderController],
};

function HeaderController(
  $cookies,
  $location,
  $log,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $translate,
  $window,
  Restangular,
  BulbActivityService,
  BulbAuthService,
  BulbBusyService,
  BulbBrowserService,
  BulbModalService,
  BulbPageService,
  BulbRecommendService,
  BulbUnitService,
  AUTHOR_TABS,
  Foundation,
  SEARCH,
  RecordEventService,
  TourService,
) {
  const that = this;
  this.currentUser = BulbAuthService.currentUser;
  this.currentUserPrefs = that.currentUser.prefs;

  this.showMobileTabs = !Foundation.utils.is_large_up() || BulbBrowserService.isMobile();
  this.showUpgrade = $state.current.name !== 'planlist';

  // Need to check if there is an error attached to the query param, if so we need this data within the headers
  // html file
  this.isErrorScreen = $stateParams.error;

  /**
   * Called on each controller after all the controllers on an element have been constructed and had their bindings
   * initialized (and before the pre & post linking functions for the directives on this element). This is a good
   * place to put initialization code for your controller.
   */
  this.$onInit = function () {
    // do all your initializations here.
    this.currentUser = BulbAuthService.currentUser;
    this.currentUserPrefs = that.currentUser.prefs;
    this.isGroupTabOpen = false;
    $scope.CONFIG = $rootScope.CONFIG;

    /**
     * The currently open header.
     */
    this.headerType = null;
    this.userUnitId = $rootScope.protofolioUserId;

    this.isHeaderFullyOpen = false;
    this.isHeaderFullyClosed = true;
    this.isRestartTour = false;

    this.helpBalloon = false;

    /**
     * The window object, used for events.
     */
    this.$window = $window;

    /**
     * Handler for subscription to the 'openControl' topic. If non-null, indicates that the subscription exists.
     * @type {Object}
     */
    this.openControlHandler = null;
    this.languages = $translate.languages;
    this.languagesList = $translate.getLanguagesList();
    this.getLanguage = $translate.getLanguage;
    this.getLanguageAsString = $translate.localeToString;

    this.moreMenuOpen = false;
    this.moreMenuTranslation = $translate.instant('MORE');
    this.isHeaderOpenedOnce = false;
  };

  const jqBodyContent = jQuery('#bulb-content');

  // Set the language in angular-translate and then reload the state so that the locale is applied through-out
  // the app.
  this.setLanguage = function (selection) {
    const selectedLanguage = (selection.selectedOption) ? selection.selectedOption : selection;
    if (selectedLanguage !== $translate.getLanguage()) {
      $translate.use(selectedLanguage);
      $cookies.put('language', selectedLanguage, {
        secure: true,
        samesite: 'None',
      });

      if (this.currentUser.isAuthenticated()) {
        that.currentUser.language = selection.selectedOption;
        const patch: any = { prefs: that.currentUser.prefs };
        patch.language = that.currentUser.language;
        BulbBusyService.showBusyDuring(
          Restangular.one('accounts', that.currentUser.id).patch(patch).then(() => {
            // Need to perform a full reload here for the language to take affect.
            $window.location.reload();
          }),
        );
      } else {
        // Need to perform a full reload here for the language to take affect.
        $window.location.reload();
      }
    }
  };

  /**
   * Determines whether to show the tour pulse badge to the user on hamburger menu.
   * @returns {boolean|any} true if badge is to be shown.
   */
  this.isTourBadgeToBeShown = function () {
    // Need to get updated prefs to render badge in realtime
    that.currentUserPrefs = BulbAuthService.currentUser.prefs;
    return (!that.currentUserPrefs.onBoarding.onboardingShowMainTour
      && that.currentUserPrefs.onBoarding.onboardingShowMenuTour && that.isHeaderFullyClosed);
  };

  // Private function to do the work of opening the specified header.
  function openHeader(headerOption) {
    // fire an event to notify interested parties
    $rootScope.$emit('headerOpened', headerOption);

    that.headerType = headerOption;
    that.isHeaderFullyClosed = false;
    // DO LATER : Setting the click function should be done in header-directive.js, which could $watch headerType.
    jqBodyContent.on('click.body', () => {
      if (that.headerType) {
        $scope.$apply(() => {
          that.headerType = null;
        });
      }
    });
  }

  /**
   * Fetch all recommends/likes when user opens the header.
   */
  $rootScope.$on('headerOpened', () => {
    // Fetch recommends only when user opens the header for the first time.
    if (!that.isHeaderOpenedOnce) {
      // Recommendations to retrieve with each RESTful request.
      const RECOMMENDATION_SIZE = 10;
      BulbRecommendService.fetchRecommends(RECOMMENDATION_SIZE);
      // Setting this to TRUE to prevent repetitive call to server when header tab opens multiple times by a user.
      that.isHeaderOpenedOnce = true;
    }
  });

  // Private function to do the work of closing whatever header is open.
  function closeHeader() {
    // notify interested parties
    $rootScope.$emit('headerClosed');

    that.headerType = null;
    that.isHeaderFullyOpen = false;
    // DO LATER : Clearing the click function should be done in header-directive.js, which could $watch headerType.
    jqBodyContent.unbind('click.body');
  }

  /**
   * Determines whether the account has new activities or not.
   * @returns {boolean|any} true if account has new activities.
   */
  this.hasNewActivities = function () {
    return BulbActivityService.activityFeed.numNewActivities > 0;
  };

  /**
   * Redirect to our 'contact' page, which is hosted in wordpress.
   */
  this.redirectToContact = function () {
    window.open(`https://${$rootScope.HOST_NAME}/h/contact/`, '_blank');
  };

  this.openHelpBalloon = function () {
    that.helpBalloon = true;
  };

  this.closeHelpBalloon = function () {
    that.helpBalloon = false;
  };
  /**
   * Open the specified header if closed, or close it if open, and trigger all related animations also handling
   * Keydown event for Enter and Spacebar as per WCAG guidlines for required Tab
   * @param event The Event emitted.
   * @param headerOption The header to be toggled.
   */
  this.toggleHeader = function (event, headerOption) {
    if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
      that.headerType === headerOption ? closeHeader() : openHeader(headerOption);
    }
  };

  /**
   * Explicitly open the header, if not already open, and trigger all related animations.
   * @param {string} headerOption The header to open.
   */
  this.openHeader = function (headerOption) {
    openHeader(headerOption);
  };

  /**
   * Update when open/close animation has finished the header.
   */
  this.openCloseDone = function () {
    $scope.$applyAsync(() => {
      if (that.headerType) {
        that.isHeaderFullyOpen = true;
        $log.debug('header fully open');
        if (that.headerType === 'general' || that.headerType === 'general-mobile') {
          TourService.startMenuTour();
        }
      } else {
        that.isHeaderFullyClosed = true;
        $log.debug('header fully closed');
        $rootScope.$emit('onHeaderFullyClosed');
      }
    });
  };

  /**
   * Handling the sign-in for Enter(13)/Space(32)/Click events as per WCAG guidlines.
   * @param event The Event triggered.
   */
  this.signIn = function (event) {
    if (event.type === 'click') {
      $state.go('signIn', {
        targetUrl: $window.location.href,
      });
    } else if (event.key === 'Enter' || event.key === ' ') {
      $state.go('signIn', {
        targetUrl: $window.location.href,
        redirected: true,
      });
    }
  };

  /**
   * Handling the sign-up for Enter(13)/Space(32)/Click events as per WCAG guidlines.
   * @param event The Event triggered.
   */
  this.signUp = function (event) {
    if (event.type === 'click') {
      // targetUrl: null allows navigating to the new author page.
      $state.go('signUp', {
        targetUrl: null,
      });
    } else if (event.key === 'Enter' || event.key === ' ') {
      $state.go('signUp', {
        targetUrl: $window.location.href,
        redirected: true,
      });
    }
  };

  this.signOut = function () {
    BulbAuthService.signOut();
  };

  this.adminExitUser = function () {
    BulbAuthService.adminExitUser();
  };

  this.goToAssetLibrary = function () {
    if ($state.includes('assetlibrary')) {
      // already at the assetlibrary, so just close the header
      closeHeader();
    } else {
      // Mobile menu doesn't close as this report.
      // https://asadigital.atlassian.net/browse/BUL-4
      // So I write the following code.
      closeHeader();
      $timeout(() => {
        $state.go('assetlibrary');
      }, 100);
    }
  };

  this.goToProfile = function () {
    if ($state.includes('author', { username: BulbAuthService.currentUser.username })) {
      // already at the profile, so just close the header
      closeHeader();
      if (that.isRestartTour) {
        $timeout(() => {
          TourService.startMainTour();
        }, 1000);
        that.isRestartTour = false;
      }
    } else {
      $state.go('author', { username: BulbAuthService.currentUser.username });
      TourService.startMainTour();
    }
  };

  this.goToSettings = function () {
    if ($state.includes('settings', { username: BulbAuthService.currentUser.username })) {
      closeHeader();
    } else {
      $state.go('account.settings', { username: BulbAuthService.currentUser.username });
    }
  };

  /**
   * Resets all the tour flags and runs the tour again for the user.
   */
  this.restartTour = function () {
    TourService.resetTourFlags();
    that.isRestartTour = true;
    that.goToProfile();
    that.toggleMoreMenu();
  };

  /**
   *  Toggles the more menu, open or close
   */
  this.toggleMoreMenu = function () {
    that.moreMenuOpen = !that.moreMenuOpen;
  };
  /**
   * Function to open the ES error model on click of search button in header
   */
  this.toggleESErrorModel = function () {
    const ESErrorModel = {
      templateUrl: 'header.ESErrorModel.nested',
      titleCode: 'Temporarily Disabled Search',
      showTitle: true,
      showCancelButton: false,
      showOkButton: false,
      fontAwesomeCode: 'fas fa-exclamation-triangle',
      windowClass: 'updated-modal-design',
    };
    BulbModalService.show(ESErrorModel);
  };

  /**
   * Return the type of unit displayed in this page.
   * Used to control whether the Create icon is displayed, and what it does.
   * @returns (string) The unit type, or if no unit is displayed, null.
   */
  this.getUnitType = function () {
    if (BulbUnitService.currentUnit) {
      return BulbUnitService.currentUnit.unitType;
    }
    return null;
  };

  this.canBuyBulbSchoolDirect = function () {
    return (BulbAuthService.currentUser.type !== 'ORG_DIRECT_SUBSCRIPTION'
      && BulbAuthService.currentUser.bulbSchoolDirectMemberships > 0
      && BulbAuthService.currentUser.type !== 'TEACHER');
  };

  this.canDisplayUpgrading = function () {
    return (BulbAuthService.currentUser.type === 'FREE'
      && !this.canDisplayUpgradeClassroom()
      && $scope.CONFIG.stripe.enabled
  && (BulbAuthService.currentUser.groupMemberships.findIndex((org) => org.type === 'ORGANIZATION') === -1))
  && !this.canBuyBulbSchoolDirect();
  };

  this.openEducatorUpgradeURL = function () {
    Restangular.all('accounts').customPOST({}, 'upgrade-classroom');
    window.open('https://my.bulbapp.com/k-12/classroom-offer/', '_blank');
  };

  this.canDisplayUpgradeClassroom = function () {
    return (BulbAuthService.currentUser.position === 'EDUCATOR'
              && (BulbAuthService.currentUser.type === 'TEACHER' || BulbAuthService.currentUser.type === 'FREE')
              && $scope.CONFIG.stripe.enabled
              && (BulbAuthService.currentUser.groupMemberships.findIndex((org) => org.type === 'ORGANIZATION') === -1))
              && !this.canBuyBulbSchoolDirect();
  };

  /**
   * Allows the user to see the organizations link in the menu, because they are an organization admin.
   */
  this.determineIdOfOrganization = function () {
    const { groupMemberships } = BulbAuthService.currentUser;

    if (groupMemberships) {
      for (let i = 0; i < groupMemberships.length; i++) {
        if (groupMemberships[i].isAdmin && groupMemberships[i].type === 'ORGANIZATION') {
          that.userAdminOfOrgId = groupMemberships[i].groupId;
          break;
        }
      }
    }
  };

  that.determineIdOfOrganization();

  /**
   * Create a new collection as a child of the author page.
   */
  this.createCollection = function () {
    RecordEventService.recordEvent('create_content_collection', 'header_controls');
    $state.go('createCollection');
  };

  /**
   * Create a new page as a child of the author page.
   *
   * DO LATER : a virtually identical method exists in the composite view controller.  Probably want to unify them.
   */
  this.createPage = function () {
    RecordEventService.recordEvent('create_content_page', 'header_controls');
    BulbPageService.createPage(BulbAuthService.currentUser.authorUnitId);
  };

  // If state is already searchresults (i.e. refresh), open the header.
  // (Must be done after this.openHeader has been defined.)
  if ($state.current.name === SEARCH.SEARCH_RESULTS_STATE) {
    that.openHeader('search');
  }

  // If state is not searchresults, close the header.
  // (Must be done after closeHeader has been defined.)
  $rootScope.$on('$stateChangeStart', (event, toState) => {
    if (toState.name !== SEARCH.SEARCH_RESULTS_STATE) {
      closeHeader();
    }
  });

  // If state is searchresults, open the search form.
  // FUTURE: It would be nice to open the header within the searchResults state or controller rather than here.
  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    if (toState.name === SEARCH.SEARCH_RESULTS_STATE) {
      // If state is searchresults, open the search form.
      // (Must be done after this.openHeader has been defined.)
      that.openHeader('search');
    }
  });

  /**
   * Handle browser resize events by making sure the header is closed, so we don't have to try to transition
   * between the two different types of headers.
   */
  $scope.$on('resize::resize', function handleResizeAcrossMobileBreakpoint() {
    /* jshint camelcase: false */
    // @ts-ignore
    const isMobile = !Foundation.utils.is_large_up() || BulbBrowserService.isMobile();
    // @ts-ignore
    if (typeof handleResizeAcrossMobileBreakpoint.wasMobile === 'undefined') {
      // @ts-ignore
      handleResizeAcrossMobileBreakpoint.wasMobile = isMobile;
      // @ts-ignore
    } else if (isMobile !== handleResizeAcrossMobileBreakpoint.wasMobile) {
      if (that.headerType !== 'search') {
        // Hide currently active onboarding menu tour on window resize as we close the header
        if (TourService.isTourActive()) {
          TourService.hideTour();
        }
        // resize event fired from outside angular, so run a digest cycle to allow header to close:
        $scope.$apply(closeHeader);
      }
      // @ts-ignore
      handleResizeAcrossMobileBreakpoint.wasMobile = isMobile;
    }
    that.showMobileTabs = isMobile;
  });

  /**
   * This method is used for listening change in route to hide upgrade button on plan list page.
   */
  $scope.$on('$locationChangeSuccess', (event) => {
    that.showUpgrade = $location.path() !== '/b/planlist';
  });

  /**
   * Handle closing the header and navigating to profile on menu tour completion.
   */
  $window.menuTourDone = function () {
    that.goToProfile();
  };

  /**
   * Navigate to the search results state with the selected search scope.
   *
   * @param query The search query.
   * @param userUnitId The unit id for portfolio-scoped searches.
   * @param scope The active search scope.
   */
  $window.searchResults = function (query, userUnitId, scope) {
    this.suggestions = [];
    $state.go('searchresults', {
      query,
      userUnitId,
      scope,
    }, {
      reload: true,
    });
  };
}

export default headerComponent;
